import { Text } from "components/Typography/text.styled";
import { useTranslation } from "react-i18next";
import {
  ActionContainer,
  OrgStructureModalBody,
} from "./organizationalStructure.styled";
import { FontSize } from "config/font";
import Modal from "@material-ui/core/Modal/Modal";
import { useState } from "react";
import { useOrganizationalStructureStore } from "web-apps/company/stores/organizationalStructureStore/organizationalStructureStore";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { TopModal } from "../general/topModal/topModal.component";
import { ButtonComponent } from "../general/button/button.component";
import { TextInputWithLabel } from "../general/textInput/textInput.component";
import { InfoModal } from "../general/infoModal/infoModal.component";
import { AxiosResponse } from "axios";

type Props = {
  setShowCreateModal: React.Dispatch<React.SetStateAction<boolean>>;
  showCreateModal: boolean;
  type: "Entity" | "Unit" | "Team";
  id?: number;
};

export const CreateModal: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [companyState] = useCompanyStore();
  const [, organizationalStructureActions] = useOrganizationalStructureStore();
  const [showInfo, setShowInfo] = useState(false);
  const [error, setError] = useState(false);

  type CreateActionType = {
    [K in "Team" | "Unit" | "Entity"]?: (
      companyId: number,
      name: string,
      parentId?: number
    ) => Promise<AxiosResponse<any>>;
  } & {
    default: (companyId: number, name: string) => Promise<AxiosResponse<any>>;
  };

  const createEndpointConfig: CreateActionType = {
    Team: (companyId, name, parentId) =>
      organizationalStructureActions.createTeam(companyId, name, parentId!),
    Unit: (companyId, name, parentId) =>
      organizationalStructureActions.createUnit(companyId, parentId!, name),
    Entity: (companyId, name) =>
      organizationalStructureActions.createEntity(companyId, name),
    default: (companyId, name) =>
      organizationalStructureActions.createEntity(companyId, name),
  };

  const getCreateEndpoint = () => {
    if (!companyState.company || !name) return null;

    const action =
      createEndpointConfig[props.type] || createEndpointConfig.default;

    if (props.type === "Entity" || !props.id) {
      return action(companyState.company.id, name);
    } else {
      return action(companyState.company.id, name, props.id);
    }
  };

  const handleCreate = () => {
    const endpoint = getCreateEndpoint();

    if (endpoint) {
      endpoint
        .then(() => {
          setError(false);
          setShowInfo(true);
        })
        .catch(() => {
          setError(true);
          setShowInfo(true);
          console.log("error when creating");
        });
    }
  };

  const closeModal = () => {
    setShowInfo(false);
    setError(false);
    setName("");
    props.setShowCreateModal(false);
  };

  return (
    <>
      <Modal
        open={props.showCreateModal}
        onClose={() => props.setShowCreateModal(false)}
      >
        <OrgStructureModalBody style={{ height: "40%", width: 700 }}>
          <TopModal
            title={t(`OrganizationalStructure.Create${props.type}`)}
            setClose={closeModal}
            marginLeft={30}
          />
          <Text style={{ width: 500, margin: "0 auto", marginLeft: 30 }}>
            {t(`OrganizationalStructure.Create${props.type}Info`)}
          </Text>
          <TextInputWithLabel
            label={t("WorkGroup.Name")}
            value={name}
            fontSize={FontSize.Standard}
            onChange={(e: any) => {
              setName(e.currentTarget.value);
            }}
            marginLeft={30}
            marginTop={20}
            maxLength={25}
          />
          <ActionContainer style={{ margin: "0 auto" }}>
            <ButtonComponent
              size={"small"}
              onClick={closeModal}
              marginTop={10}
              marginBottom={20}
              marginRight={10}
            >
              {t("OrganizationalStructure.Cancel")}
            </ButtonComponent>
            <ButtonComponent
              size={"small"}
              onClick={handleCreate}
              action={true}
              marginTop={10}
              marginBottom={20}
              disabled={!name.trim()}
            >
              {t(`OrganizationalStructure.Create${props.type}`)}
            </ButtonComponent>
          </ActionContainer>
        </OrgStructureModalBody>
      </Modal>
      {showInfo && (
        <InfoModal
          isOpen={showInfo}
          title={
            error
              ? t("OrganizationalStructure.SomethingWentWrong")
              : t("OrganizationalStructure.Created")
          }
          message={
            error
              ? t("OrganizationalStructure.SomethingWentWrongInfo")
              : t(`OrganizationalStructure.SuccessfullyCreated`, {
                  type: props.type,
                })
          }
          confirmText={t("OrganizationalStructure.Ok")}
          onConfirm={closeModal}
          onCancel={closeModal}
        />
      )}
    </>
  );
};
